
export default class InscricaoUtils {

    static validaCei(valor) {

        var cNumero = valor.substring(0, 11);
        var nDv = valor.substring(11, 12);
        var nSoma = 0;
        var cMat = " ";
        var matriz = "74185216374";
        var nTam = 0;
        var nDvCalc = 0;

        for (var i = 0; i <= 10; i++) {
            nSoma = nSoma + (cNumero.substring(i, i + 1) * parseInt(matriz.substring(i, i + 1)));
        }
        var nSoma1 = nSoma + "";
        nTam = nSoma1.length;
        var nAux = (parseInt(nSoma1.substring(0, nTam - 1)) * 1) + (parseInt(nSoma1.substring(nTam - 1, nTam)) * 1);
        var nAux1 = nAux + "";
        nTam = nAux1.length;
        if (nTam == 1) {
            var nUnidade = nAux1.substring(0, 1);
        }
        else {
            var nUnidade = nAux1.substring(1, 2);
        }

        nDvCalc = 10 - (parseInt(nUnidade) * 1);
        if (nDvCalc > 9) {
            nDvCalc = 0;
        }

        if (nDvCalc == nDv) {
            return true;
        }
        else {
            return false;
        }

    }

    /**
     * Inscricao com mascara de acordo com tipo informado.
     * @param tpInscricao tipo da Inscricao
     * @param inscricao numero da Inscricao
     * @returns Inscricao com mascara.
     */
    static mascararInscricao(tpInscricao: string, inscricao: number): string {
        switch (tpInscricao) {
            case '1':
                return InscricaoUtils.mascararCNPJ(inscricao + '');
            case '2':
                return InscricaoUtils.mascararCEI(inscricao + '');
            case '3':
                return InscricaoUtils.mascararCPF(inscricao + '');
            case '4':
                return InscricaoUtils.mascararNIS(inscricao + '');    
        }
    }

    static mascararCNPJ(nu_cnpj) {
        //'00.000.000/0000-00'
        return nu_cnpj.substring(1, 3) + "." + nu_cnpj.substring(3, 6) + "." + nu_cnpj.substring(6, 9) + "/" + nu_cnpj.substring(9, 13) + "-" + nu_cnpj.substring(13, 15);
    }

    /**
     * Retorna incricao CPF com mascara
     * @param nu_cpf inscricao tipo CPF
     * @returns incricao CPF com mascara
     */
    static mascararCPF(nu_cpf) {
        if (nu_cpf.length == 15) {
            nu_cpf = nu_cpf.substring(4, 15);
        }
        return nu_cpf.substring(0, 3) + "." + nu_cpf.substring(3, 6) + "." + nu_cpf.substring(6, 9) + "-" + nu_cpf.substring(9, 11);
    }

    static mascararCEI(nu_cei: string) {
        if (nu_cei.length == 12)
            nu_cei = "200" + nu_cei;

        return nu_cei.substring(3, 5) + "." + nu_cei.substring(5, 8) + "." + nu_cei.substring(8, 13) + "-" + nu_cei.substring(13, 15);
    }

    static mascararNIS(nu_nis: string) {
        if (nu_nis.length == 15)
            nu_nis = nu_nis.substring(4, 15);;

        return nu_nis.toString().substring(0, 10) + '-' + nu_nis.toString().substring(10)
    }

    static unmaskInscricao(val: string) {
        return val.replace(/\D/g, '');
    }

    static formatoMascara(tpInscricao: number) {
        switch (tpInscricao) {
            case 1:
                return '00.000.000/0000-00'
            case 3:
                return '000.000.000-00'
            case 2:
                return '00.000.00000/00'
            case 4:
                return '0000000000-0'
        }
    }

    static inscricaoQuinzeDigitos(inscricao: string, tipoInscricao: string): string {

        const strInscricao = inscricao.toString();
        switch (tipoInscricao) {
            case '1':
                if (strInscricao.length === 14)
                    return '1' + inscricao
            case '2':
                if (strInscricao.length === 12)
                    return '200' + inscricao;
                else
                    return inscricao + '';
            case '3':
                if (strInscricao.length === 11)
                    return '3000' + inscricao;
                else
                    return inscricao + '';
            case '4':
                if (strInscricao.length === 11)
                    return '4000' + inscricao;
                else
                    return inscricao + '';
        }
    }

    static retirarTipoInscricaoCNPJ(inscricao) {
        return inscricao.toString().length === 15 ? inscricao.toString().substring(1, (inscricao.toString().length)) : inscricao;
    }

    static formatarInscricao(inscricao, tipo) {
        tipo = tipo === null || tipo === undefined ? (inscricao.toString().substring(0, 1)) : tipo;
        const tamanho = inscricao.toString().length;
        let inscr = inscricao;
        let posicao;
        switch (tipo) {
            //CEI
            case '2':
                if (!this.tamanhoQuinze(tamanho, 12)) {
                    posicao = tamanho - 12;
                    //descarto '?00'
                    inscr = inscricao.toString().substring(posicao, tamanho);
                }
                break;
            //CNPJ
            case '1':
                if (!this.tamanhoQuinze(tamanho, 14)) {
                    posicao = tamanho - 14;
                    //descarto '1'
                    inscr = inscricao.toString().substring(posicao, tamanho);
                }
                if (tamanho == 14) {
                    inscr = inscricao.toString().substring(posicao, tamanho);
                }
                break;
            //CPF
            case '3':
                if (!this.tamanhoQuinze(tamanho, 11)) {
                    posicao = tamanho - 11;
                    inscr = inscricao.toString().substring(posicao, tamanho);
                }
                break;
            default:
                if (this.tamanhoQuinze(tamanho, 11)) {
                    inscr = inscricao.toString().substring(3, tamanho);
                }
                break;
        }
        return inscr;
    }

    static tamanhoQuinze(tamanho, tamanhoReal): boolean {
        return tamanho === tamanhoReal;
    }

    static isInscricaoPF(nu_inscricao: string) {
        //digitos completos e indicador PF
        return nu_inscricao.length == 15 && nu_inscricao.startsWith('3');
    }

    static rotuloInscricao(tpInscricao: string): string {
        switch (tpInscricao) {
            case '3':
                return 'CPF: ';
            case '2':
                return 'CEI: ';
            case '1':
                return 'CNPJ: ';
            default:
                return 'Inscricao: '
        }
    }
}